import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost';
const PORT = process.env.REACT_APP_API_PORT || '4000';

const cleanURL = BASE_URL.endsWith('/') ? BASE_URL.slice(0, -1) : BASE_URL;

const api = axios.create({
    baseURL: `${cleanURL}:${PORT}/api`,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

export const setupResponseInterceptor = (handleLogout) => {
    const interceptor = api.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                const errorData = error.response.data;
                if (errorData?.message?.includes('expired') || errorData?.error?.includes('jwt')) {
                    handleLogout();
                }
            }
            return Promise.reject(error);
        }
    );
    return interceptor;
};

export default api;